export default {
  state: {
    partnerInfo: {},
    isLogin: false
  },
  getters: {
    getUser: state => {
      if (!state.isLogin && localStorage.getItem('partnerInfo')) {
        let info = JSON.parse(localStorage.getItem('partnerInfo'))
        state.partnerInfo = info
        state.isLogin = true
      }
      return state
    }
  },
  mutations: {
    setUser (state, u) {
      let lastLoginTime = new Date().getTime()
      localStorage.setItem('partnerInfo', JSON.stringify(u))
      localStorage.setItem('lastLoginTime', lastLoginTime)
      state.partnerInfo = u
      state.isLogin = true
    },
    delUser (state) {
      localStorage.removeItem('partnerInfo')
      localStorage.setItem('lastLoginTime', 0)
      state = {
        partnerInfo: {},
        isLogin: false
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/user.js